var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollection = function SvgCollection(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 22.5L20.6667 24.1667C20.6667 24.1667 33.1667 21.6667 34.8333 21.6667C36.5 21.6667 36.5 23.3333 34.8333 25C33.1667 26.6667 27.3333 31.6667 22.3333 31.6667C17.3333 31.6667 14 29.1667 10.6667 29.1667H2.33333",
    stroke: "#B9C4CE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 19.1667C4 17.5 7.33333 15 10.6667 15C14 15 21.9167 18.3333 23.1667 20C24.4167 21.6667 20.6667 24.1667 20.6667 24.1667M12.3333 9.99999V3.33332C12.3333 2.8913 12.5089 2.46737 12.8215 2.15481C13.1341 1.84225 13.558 1.66666 14 1.66666H34C34.442 1.66666 34.866 1.84225 35.1785 2.15481C35.4911 2.46737 35.6667 2.8913 35.6667 3.33332V16.6667",
    stroke: "#B9C4CE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 1.66666H28.1667V9.16666H19.8333V1.66666Z",
    stroke: "#B9C4CE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "collection.167fee589dab307968f9760d7cd5203f.svg";